var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6668 6.99399H9.60012V4.86063C9.60012 2.78059 7.94676 1.12723 5.86673 1.12723C3.78669 1.12723 2.13333 2.78059 2.13333 4.86063V6.99399H1.06665V4.86063C1.06665 2.19391 3.20002 0.0605469 5.86673 0.0605469C8.53344 0.0605469 10.6668 2.19391 10.6668 4.86063V6.99399Z",
    fill: "#8E8D8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1335 16.0606H1.60003C0.693345 16.0606 0 15.3673 0 14.4606V8.06048C0 7.15379 0.693345 6.46045 1.60003 6.46045H10.1335C11.0402 6.46045 11.7335 7.15379 11.7335 8.06048V14.4606C11.7335 15.3673 11.0402 16.0606 10.1335 16.0606ZM1.60003 7.52713C1.28002 7.52713 1.06668 7.74047 1.06668 8.06048V14.4606C1.06668 14.7806 1.28002 14.9939 1.60003 14.9939H10.1335C10.4535 14.9939 10.6668 14.7806 10.6668 14.4606V8.06048C10.6668 7.74047 10.4535 7.52713 10.1335 7.52713H1.60003Z",
    fill: "#8E8D8D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.86673 10.727C6.45585 10.727 6.93342 10.2494 6.93342 9.66031C6.93342 9.0712 6.45585 8.59363 5.86673 8.59363C5.27762 8.59363 4.80005 9.0712 4.80005 9.66031C4.80005 10.2494 5.27762 10.727 5.86673 10.727Z",
    fill: "#8E8D8D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.13358 9.65918H5.60024L5.06689 12.8592H6.66692L6.13358 9.65918Z",
    fill: "#8E8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lockIcon.e64790208a608054b6f28e1e54bc68fb.svg";
export { ForwardRef as ReactComponent };